import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { IWizItemRenderer, WizLabel, WizBaseCollector, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent, ScenarioStepParameterVO } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';

/** Renderer vignette d'une mesure */
@Component({
  selector: 'scen-step-renderer',
  templateUrl: './scen-step.renderer.html',
})
export class ScenStepRenderer implements IWizItemRenderer<null, ScenarioStepParameterVO> {
  constructor(public elementRef: ElementRef) {}

  @HostBinding('class.thumb') public thumb: boolean = true;

  @ViewChild('lbTitle') lbTitle: WizLabel;
  @ViewChild('lbContent') lbContent: WizLabel;

  public editable: boolean = false; 
  public visible: boolean = false; 

  public trsLabel: string = '';

  owner: WizBaseCollector;

  private _data: ScenarioStepParameterVO;
  public get data(): ScenarioStepParameterVO {
    return this._data;
  }
  @Input()
  public set data(data: ScenarioStepParameterVO) {
    this._data = data;
    this.trsLabel = this.data.trsLabel;
    this.editable = this.data.editable;
    this.visible = this.data.visible;

  }


  public doAdd(e: Event): void {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.ADD_MEASURE, this.data));
  }

}
